<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="tabulator-parent">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-messages"></i> {{ _('Communication') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('messages')" class="tab-pane active" id="messages" v-if="isTabActive('messages')" key="messages">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('General messages') }}</h3>
                <div class="panel-group">
                  <p>{{ _('These messages are shown in various parts of your shop and in the order process.') }} {{ _('Click the titles for more information.') }}</p>
                  <template v-for="msg in additionalMessageTypes" :key="msg.type">
                    <div :class="messagePanelClass(msg.type)" :id="msg.type">
                      <div class="panel-heading" role="tab">
                        <h4 class="panel-title">
                        <a href="javascript:;" v-on:click="modifyMessage(msg)">
                          <i :class="messageIconClass(msg.type)"></i>{{ _(msg.title) }}
                        </a>
                        </h4>
                      </div>
                    </div>
                    <div class="row" v-if="msg.type === 'deliveryTerms'">
                      <div class="col-xs-12" style="padding-left: 30px">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="settings.orderrequest_cancellation" true-value="1" false-value="0" />{{ _('Allow customers to request order cancellation') }}
                          </label>
                        </div>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="settings.orderrequest_move" true-value="1" false-value="0" />{{ _('Allow customers to request reservation moves') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('emails')" class="tab-pane active" id="emails" v-if="isTabActive('emails')" key="emails">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Emails') }}</h3>
                <div class="panel-group">
                  <p>{{ _('These messages are sent to customers by email when certain events occur.') }} {{ _('Click the titles for more information.') }}</p>
                  <div v-for="msg in messageTypes" :class="messagePanelClass(msg.type)" :id="msg.type">
                    <div class="panel-heading" role="tab">
                      <h4 class="panel-title">
                      <a href="javascript:;" v-on:click="modifyMessage(msg)">
                        <i :class="messageIconClass(msg.type)"></i>{{ _(msg.title) }}
                      </a>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-12">
                <h3>{{ _('Message sender information') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group languageversioned">
                  <label for="sendername">{{ _('Sender name') }}</label>
                  <input type="text" class="form-control" id="senderName" :placeholder="_('Enter the message sender\'s name')" v-model="settings.sendername" />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="senderemail">{{ _('Sender email') }}</label>
                  <input type="email" class="form-control" id="senderEmail" :placeholder="_('Enter the message sender\'s email')" v-model="settings.senderemail" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <label>
                  <input type="checkbox" v-model="settings.sendtoself" true-value="1" false-value="0" /> {{ _('Send a copy of confirmation messages to sender') }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <input type="hidden" v-model="settings.sms_gateway" />
                <div class="form-group languageversioned" v-if="settings.sms_gateway2_sender && settings.sms_gateway2_sender !== 'Johku'">
                  <label for="sms_gateway2_sender">{{ _('Sender name') }}</label>
                  <input type="text" class="form-control" id="smsGateway2Sender" :placeholder="_('Enter your SMS sender name')" v-model="settings.sms_gateway2_sender" />
                </div>
              </div>
              <div class="col-sm-6" v-if="false">
                <h4>{{ _('Social Profiles') }}</h4>
                <div class="form-group">
                  <label for="profile_facebook">{{ _('Facebook') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1"><i class="fa fa-fw fa-facebook"></i> facebook.com /</span>
                    <input type="text" class="form-control" :placeholder="_('facebookurl')" v-model="settings.profile_facebook" aria-describedby="basic-addon1" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="profile_twitter">{{ _('Twitter') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2"><i class="fa fa-fw fa-twitter"></i> twitter.com /</span>
                    <input type="text" class="form-control" :placeholder="_('twitterurl')" v-model="settings.profile_twitter" aria-describedby="basic-addon2" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="profile_linkedin">{{ _('LinkedIn') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon3"><i class="fa fa-fw fa-linkedin"></i> linkedin.com /</span>
                    <input type="text" class="form-control" :placeholder="_('linkedinurl')" v-model="settings.profile_linkedin" aria-describedby="basic-addon3" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="profile_google">{{ _('Google+') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon4"><i class="fa fa-fw fa-google"></i> plus.google.com /</span>
                    <input type="text" class="form-control" :placeholder="_('googleplusurl')" v-model="settings.profile_google" aria-describedby="basic-addon4" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('terms')" class="tab-pane active" id="terms" v-if="isTabActive('terms')" key="terms">
            <div class="row">
              <div class="col-xs-6">
                <h3>{{ _('Product-specific terms') }}</h3>
              </div>
              <div class="col-xs-6">
                <button type="button" class="btn btn-success pull-right new-terms" v-on:click="addTermsDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New terms') }}</button>
              </div>
            </div>
            <Datatable :url="termsUrl" :options="termsTableOptions" ref="datatableTerms" />
          </div>
          <div v-bind="tabPanel('forms')" class="tab-pane active" id="forms" v-if="isTabActive('forms')" key="forms">
            <template v-if="!isFeatureEnabled('forms')">
              <div class="row">
                <div class="col-xs-6">
                  <h3>{{ _('Forms') }}</h3>
                  <p><i><strong>{{ _('Forms are a paid feature. Please contact customer support to enable them.') }}</strong></i></p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xs-6">
                  <h3>{{ _('Forms') }}</h3>
                </div>
                <div class="col-xs-6">
                  <button type="button" class="btn btn-success pull-right new-form" v-on:click="addFormDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New form') }}</button>
                </div>
              </div>
              <Datatable :url="formsUrl" :options="formsTableOptions" ref="datatableForms" />
            </template>
          </div>
          <div v-bind="tabPanel('templates')" class="tab-pane active" id="templates" v-if="isTabActive('templates')" key="templates">
            <div class="row">
              <div class="col-xs-6">
                <h3>{{ _('Templates') }}</h3>
              </div>
              <div class="col-xs-6">
                <button type="button" class="btn btn-success pull-right new-form" v-on:click="addTemplateDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New template') }}</button>
              </div>
            </div>
            <Datatable :url="templatesUrl" :search="templateSearch" :options="templateTableOptions" ref="datatableTemplates" v-on:data="templateTableEvent" />
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar" v-if="isSaveBarVisible">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button v-if="isSaveButtonVisible" class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled" :style="isDetailsColumnOpen ? 'opacity: 0;' : ''"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
            <button v-if="isCloseButtonVisible" class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import componenttypes from '~/lib/componenttypes'
import formatters from '~/lib/formatters'
import forms from '~/lib/forms'
import messagetypes from '~/lib/messagetypes'
import settingseditors from '~/lib/settingseditors'
import Datatable from '~/components/Datatable'
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      activeTab: 'messages',
      termsTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          formatter: this.termsNameFormatter(),
          widthGrow: 4,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editTerms(id, name)
        }
      },
      formsTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editForm(id, name)
        }
      },
      templates: [],
      templateSearch: '',
      templateTableOptions: {
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 4,
          formatter: this.templateTypeFormatter()
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          $this.editTemplateRow(row)
        }
      }
    }
  },
  mixins: [components, componenttypes, formatters, forms, messagetypes, settingseditors],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'messages', label: this._('Terms and standard messages') },
        { id: 'emails', label: this._('Emails') },
        { id: 'terms', label: this._('Product-specific terms') },
        { id: 'forms', label: this._('Forms'), hidden: !this.isFeatureEnabled('forms') },
        { id: 'templates', label: this._('Templates') }
      ])
    },
    settings: {
      get () {
        return this.localSettings ? this.localSettings : this.shopSettings(this.shopId)
      },
      set (newValue) {
        this.localSettings = newValue
      }
    },
    editorConfig () {
      return {
        toolbar:
          [
            ['Format', 'Bold', 'Italic', '-', 'NumberedList', 'BulletedList', 'Outdent', 'Indent', '-', 'Link', 'Unlink'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['Undo', 'Redo'],
            ['Source'],
            ['UIColor']
          ],
        height: '150px',
        language: this.shortLocale,
        allowedContent: true,
        extraPlugins: 'justify'
      }
    },
    termsUrl () {
      return this.baseDomain + this.shopId + '/terms.json?apikey=' + this.apiKey + '&version=' + this.version
    },
    formsUrl () {
      return this.baseDomain + this.shopId + '/forms.json?apikey=' + this.apiKey + '&version=' + this.version
    },
    templatesUrl () {
      return this.baseDomain + this.shopId + '/templates.json?apikey=' + this.apiKey
    },
    isSaveBarVisible () {
      return this.isSaveButtonVisible || this.isCloseButtonVisible
    },
    isSaveButtonEnabled () {
      return !this.saving && !this.saved && !this.loading && !this.locked && !this.isDetailsColumnOpen 
    },
    isDetailsColumnOpen () {
      return !!(this.columns && this.columns.find(c => c.identifier === 'details'))
    },
    isSaveButtonVisible () {
      return this.activeTab === 'emails' || this.unsavedChanges
    },
    isCloseButtonVisible () {
      return this.isModal
    }
  },
  methods: {
    addTermsDialog () {
      this.showDialog({
        title: this._('Create new Product-specific terms'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Save'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'description'],
            handler: (data) => {
              this.addTerms(data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            localized: true
          },
          {
            title: this._('Description'),
            type: 'textarea',
            editor: 'richEditor',
            name: 'description',
            localized: true
          }
        ]
      })
    },
    async addTerms (data) {
      let response
      const d = {
        name: data.name,
        description: data.description,
        version: this.version
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/terms.json?apikey=' + this.apiKey + this.versionStr, d)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    async editTerms (id, name, activeTab, skipState) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/terms/' + id + '.json?apikey=' + this.apiKey + this.versionStr)
      } catch(e) {
        this.showError(e)
        return
      }
      const terms = response.data
      this.showDialog({
        title: this._('Modify terms'),
        width: 800,
        buttons: [
          {
            title: this._('Delete'),
            icon: 'trash',
            class: 'danger',
            handler: () => {
              setTimeout(() => {
                this.deleteTermsDialog(id)
              }, 1)
            }
          },
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Save'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'description'],
            handler: (data) => {
              data.id = id
              data.version = this.version
              this.modifyTerms(id, data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            defaultValue: terms.name,
            localized: true
          },
          {
            title: this._('Description'),
            type: 'textarea',
            editor: 'richEditor',
            name: 'description',
            defaultValue: terms.description,
            localized: true
          }
        ]
      })      
    },
    async modifyTerms (id, data) {
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/terms/' + id + '.json?apikey=' + this.apiKey + this.versionStr, data)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    deleteTermsDialog (id) {
      this.showDialog({
        title: this._('Are you sure? Deletion can\'t be undone.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            handler: () => {}
          },
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.deleteTerms(id)
            }
          }
        ]
      })
    },
    async deleteTerms (id) {
      let response
      try {
        response = await axios.delete(this.baseDomain + this.shopId + '/terms/' + id + '.json?apikey=' + this.apiKey + this.versionStr)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    modifyMessage (msg) {
      //let message = this.messages.find(m => m.type === msg.type)
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'MessageDetails',
        title: this._('Message'),
        width: 6,
        data: {
          type: msg.type
        }
      })
    },
    isMessageDefined (index) {
      return this.messages && this.messages.findIndex(m => m.type === index) !== -1
    },
    messagePanelClass (index) {
      return 'panel panel-' + (this.isMessageDefined(index) ? 'info' : 'default')
    },
    messageIconClass (index) {
      return 'fa fa-fw fa-' + (this.isMessageDefined(index) ? 'check' : 'warning') + ' pull-right'
    },
    getSaveData () {
      const exportFields = [
        'id', 
        'senderemail',
        'sendername',
        'sendtoself',
        'sms_gateway',
        'sms_gateway2_sender',
        'orderrequest_cancellation',
        'orderrequest_move',
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.settings[e], a), {})
      data.communication = 1
      data.version = this.version
      return data
    },    
    async save (payment) {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, data)
        } else {
          this.saving = false
          return
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.settings)
      this.close()
    },
    reloadTermsList () {
      if (this.$refs && this.$refs.datatableTerms) {
        this.$refs.datatableTerms.reload()
      }
    },
    reloadFormsList () {
      if (this.isFeatureEnabled('forms') && this.$refs && this.$refs.datatableForms) {
        this.$refs.datatableForms.reload()
      }
    },
    loadVersionedSettings () {
      return new Promise(async (resolve, reject) => {
        const settings = await this.loadSettings()
        const loaders = []
        loaders.push(this.loadMessages())
        resolve(settings)
      })
    },
    templateTableEvent (data) { // This overrides the default event handler because the templates table has non-standard variables for search
      if (data) {
        if (data.filters) {
          for (let i = 0; i < data.filters.length; i++) {
            let f = data.filters[i]
            switch (f.field) {
              case 'search':
                if (!this.templateSearch) { // We need to check this, otherwise the search field will start "eating" characters
                  this.templateSearch = f.value
                }
                break
            }
          }
        }
      }
    },
    editTemplateRow (row) {
      let id = row.getCell('id').getValue()
      let name = row.getCell('name').getValue()
      this.editTemplate(id, name)
    },
    editTemplate (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'TemplateDetails',
        title: this._('Template') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          templateId: id
        },
        skipState
      })
    },
    addTemplateDialog () {
      this.showDialog({
        title: this._('New template'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'type'],
            handler: this.createTemplate
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          },
          {
            title: this._('Type'),
            type: 'select',
            name: 'type',
            options: [
              {
                value: 'posreceipt.tpl',
                name: this._('POS receipt')
              },
              {
                value: 'posticket.tpl',
                name: this._('POS ticket')
              },
              {
                value: 'bocaticket.tpl',
                name: this._('POS ticket') + ' (BOCA)'
              },
              {
                value: 'pdfvaluecard.tpl',
                name: this._('PDF value card')
              },
            ]
          }
        ]
      })
    },
    async createTemplate (data) {
      let response
      let d = {
        name: data.name,
        type: data.type
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/templates.json?apikey=' + this.apiKey, d)
        if (response.data) {
          this.editTemplate(response.data, data.name)
        }
      } catch(e) {
        this.showError(e)
      }
    },
    reloadTemplatesList () {
      this.$refs.datatableTemplates.reload()
    }    
  },
  components: {
    Datatable
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['messageUpdate'] = (message) => {
        return this.loadMessages()
      }
      events['formUpdate'] = (message) => {
        return this.reloadFormsList()
      }
      events['termsUpdate'] = (message) => {
        return this.reloadTermsList()
      }
      events['templateUpdate'] = debounce((message) => {
        return this.reloadTemplatesList()
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'TemplateDetails':
            this.editTemplate(message.data.templateId, null, true)
            break
          default:
            if (message.data && message.data.type) {
              this.modifyMessage(message.data)
            }
            break
        }
      }
      this.events = events
    }
    this.enableEventBus()

    const settings = await this.loadVersionedSettings()
    this.origSettings = Object.assign({}, settings)
    this.localSettings = Object.assign({}, settings)
    this.storeState()

  }
}
</script>